import {
   ADD_RECEIVE_LINE_ITEM,
   UPDATE_RECEIVE_LINE_ITEM,
   GET_RECEIVE_LINE_ITEM,
   GET_RECEIVES_LINE_ITEM,
   DELETE_RECEIVE_LINE_ITEM,
} from '../types';

const initialState = { list: [], single: null };

const reducer = (state = initialState, action) => {
   const { type, payload } = action;

   switch (type) {
      case GET_RECEIVES_LINE_ITEM:
         return { ...state, list: payload };
      case GET_RECEIVE_LINE_ITEM:
         return { ...state, single: payload || initialState.single };

      case UPDATE_RECEIVE_LINE_ITEM:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
         };

      case ADD_RECEIVE_LINE_ITEM:
         return {
            ...state,
            list: [payload, ...state.list],
         };

      case DELETE_RECEIVE_LINE_ITEM:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
         };

      default:
         return state;
   }
};

export default reducer;
